import { CheckBoxFields } from '@/lib/types';

export const checkBoxFormFields: CheckBoxFields[] = [
  {
    id: 'email',
    name: 'Email',
  },
  {
    id: 'phone',
    name: 'Phone',
  },
  {
    id: 'no-preference',
    name: 'No Preference',
  },
];
